/**
 * Exact component codes from backend `SOLVERA_COMPONENT_SPECS` titles
 * (see django/osapi/solvera/components.py).
 */
export const SOLVERA_COMPONENT_CODES = [
  'Solvera Sunshine Guarantee - Residential (Up to 4 kW)',
  'Solvera Sunshine Guarantee - Residential (4-6 kW)',
  'Solvera Sunshine Guarantee - Residential (6-8 kW)',
  'Solvera Sunshine Guarantee - Commercial (Up to 10 kW)',
  'Solvera Sunshine Guarantee - Commercial (10-20 kW)',
  'Solvera Sunshine Guarantee - Commercial (20-30 kW)',
  'Solvera Sunshine Guarantee - Commercial (30-40 kW)',
  'Solvera Sunshine Guarantee - Commercial (40-50 kW)',
  'Solvera Sunshine Guarantee - Commercial (50-100 kW)',
  'Solvera Sunshine Guarantee - Commercial (100-150 kW)',
  'Solvera Sunshine Guarantee - Commercial (150-200 kW)',
  'Solvera Sunshine Guarantee - Commercial (200-250 kW)',
  'Solvera Sunshine Guarantee - Commercial (250-300 kW)',
] as const

const SOLVERA_COMPONENT_CODE_SET = new Set<string>(SOLVERA_COMPONENT_CODES)

export const SOLVERA_MANUAL_SELECTION_BLOCKED_MESSAGE =
  "This component can't be added manually because it is managed by the Solvera Sunshine Guarantee integration."

export const isSolveraComponentCode = (code: string | null | undefined): boolean => {
  if (!code) return false
  return SOLVERA_COMPONENT_CODE_SET.has(code)
}

export const shouldBlockManualSolveraComponentSelection = ({
  componentType,
  code,
  autoAdded,
  authoredBy,
}: {
  componentType: string
  code?: string | null
  autoAdded?: boolean
  authoredBy?: string
}): boolean => {
  if (componentType !== 'other') return false
  if (autoAdded || authoredBy) return false
  return isSolveraComponentCode(code)
}
